import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { User } from "../../_objects/user";
import { LoggedInUserDbService } from "../database/logged-in-user-db.service";
import { MeUserContractService } from "../interfaces/me-user-contract.service";
import { CurrentUserSchema } from "./../../_offline/models/current-user.schema";
import { AppInfoDbService } from "./../database/app-info-db.service";
import { CurrentUserDbService } from "./../database/current-user-db.service";

@Injectable({
  providedIn: "root"
})
export class MeUserOfflineService implements MeUserContractService {
  constructor(
    private appInfoDbService: AppInfoDbService,
    private currentUserDbService: CurrentUserDbService,
    private loggedInUserDbService: LoggedInUserDbService
  ) {}

  getMe(): Observable<User> {
    return this.loggedInUserDbService.getCurrentUser().pipe(
      map((schema) => {
        const result = new User();
        result.id = schema.id;
        result.givenName = schema.givenName;
        result.surname = schema.surname;
        result.initials = schema.initials;
        result.isAgreedTerms = schema.isAgreedTerms;
        result.accountEnabled = schema.accountEnabled;
        result.country = schema.country;
        result.schemaVersion = schema.schemaVersion;
        result.tenantAttributes = JSON.parse(schema.tenantAttributes);
        return result;
      })
    );
  }

  putUserAgreeTerms(): Observable<User> {
    const result: Subject<User> = new Subject<User>();
    let user: User;

    this.appInfoDbService
      .get()
      .pipe(
        switchMap((x) => {
          return this.getMe();
        }),
        switchMap((x) => this.loggedInUserDbService.putIsAgreedTerms(x.id, true)),
        switchMap(() => this.getMe()),
        switchMap((x) => {
          user = x;
          return this.currentUserDbService.put(new CurrentUserSchema(user));
        })
      )
      .subscribe(() => {
        result.next(user);
        result.complete();
      });

    return result;
  }
}
